import React from "react";
import { Link } from "react-router-dom"; // Importer Link pour la navigation

const reviews = [
  {
    name: "Louay Tbessi",
    comment: "Dr Cherkaoui Abir est une dentiste exceptionnelle et très compétente. Un excellent accueil et soins de qualité. Je recommande vivement",
    rating: 5,
  },
  {
    name: "Ziyad HAMED",
    comment: "Je suis extrêmement satisfait des soins reçus chez docteur Cherkaoui. Elle fait preuve d’un grand professionnalisme et de beaucoup de douceur, ce qui rend chaque visite agréable. Je recommande vivement pour des soins dentaires de qualité !",
    rating: 5,
  },
  {
    name: "Rihab Nadifi",
    comment: "Je recommande vivement ce centre dentaire. Dr Cherkaoui Abir est une excellente dentiste qui offre des soins de qualité et prend le temps d’expliquer chaque étape du traitement. L’équipe également est à l’écoute et très professionnelle.",
    rating: 5,
  },
];

const Reviews = () => {
  return (
    <section className="bg-gray-50 py-10 px-4 md:px-20">
      <h2 className="text-2xl md:text-3xl font-bold text-center text-customAqua600 mb-6">
        Avis de nos Patients
      </h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {reviews.map((review, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-xl p-4 hover:shadow-xl transition duration-300"
          >
            <h3 className="font-semibold text-customAqua600">{review.name}</h3>
            <p className="text-sm text-gray-600 mt-2">{review.comment}</p>
            <div className="flex mt-2 text-yellow-400">
              {"⭐".repeat(review.rating)}             {"☆".repeat(5 - review.rating)}          </div>
          </div>
        ))}
      </div>

      {/* Ajouter le bouton "Voir Plus" */}
      <div className="text-center mt-8">
        <Link
          to="/more-reviews"
          className="inline-block bg-customAqua600 text-white px-6 py-2 rounded-full hover:bg-customAqua700 transition duration-300"
        >
          Ajouter votre Review
        </Link>
      </div>
    </section>
  );
};

export default Reviews;
